import Vue from 'vue'
import Vuex from 'vuex'
import { login as apiLogin, getUserInfo, logout as apiLogout } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      name: '',
      role: '系统最高管理员',
      avatar: ''
    },
    roles: [],       // 用户角色列表
    permissions: [], // 用户权限标识列表
    menus: []        // 动态菜单
  },
  getters: {
    hasPermission: (state) => (slug) => {
      return state.permissions.includes(slug)
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_MENUS(state, menus) {
      state.menus = menus
    }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        apiLogin(credentials).then(res => {
          const { token, user } = res
          localStorage.setItem('admin_token', token)
          commit('SET_USER', user)
          resolve(user)
        }).catch(err => {
          reject(err)
        })
      })
    },
    fetchUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          commit('SET_USER', {
            name: res.name || res.username,
            role: res.role || '系统最高管理员',
            avatar: res.avatar || ''
          })
          commit('SET_ROLES', res.roles || [])
          commit('SET_PERMISSIONS', res.permissions || [])
          commit('SET_MENUS', res.menus || [])
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        apiLogout().catch(() => {})
        commit('SET_USER', { name: '', role: '', avatar: '' })
        commit('SET_ROLES', [])
        commit('SET_PERMISSIONS', [])
        commit('SET_MENUS', [])
        localStorage.removeItem('admin_token')
        resolve()
      })
    }
  }
})
